import React from 'react';
import './NVivoDashboard.css';

/**
 * In-app NVivo dashboard shell. Content will be built here (no external redirect).
 */
export default function NVivoDashboard() {
  return (
    <div className="nvivo-dashboard-page">
      <header className="nvivo-dashboard-header">
        <h1 className="nvivo-dashboard-title">NVIVO Dashboard</h1>
        <p className="nvivo-dashboard-subtitle">
          Qualitative insights and coding views for the Assume We Can research will live here.
        </p>
      </header>

      <div className="nvivo-dashboard-body">
        <section className="nvivo-dashboard-placeholder" aria-labelledby="nvivo-coming-soon-heading">
          <h2 id="nvivo-coming-soon-heading" className="nvivo-dashboard-placeholder-title">
            Dashboard coming soon
          </h2>
          <p className="nvivo-dashboard-placeholder-text">
            This space is reserved for the in-app NVIVO dashboard. Content and tools will be added here as we build
            them out.
          </p>
        </section>
      </div>
    </div>
  );
}
